<div class="inner-modal-content">
    <p class="title is-level-2 has-text-centered">Avant de découvrir ce mobile HUAWEI</p>

    <section class="section has-background-white section-content-huawei">
        <div class="columns is-mobile is-multiline">
            <div class="column has-text-centered">
                <p>
                    Le nouveau smartphone {{ phoneName }}, doté du système d’exploitation Android utilise les Huawei
                    Mobile Services.
                    <span class="has-text-weight-semibold">
                        Cela signifie que les services et applications Google (Play Store, Recherche Google, Chrome,
                        Gmail, Youtube, Maps…) ne sont pas intégrés et ne fonctionnent pas sur ce smartphone.
                    </span>
                </p>
                <p>
                    Cependant, le {{ phoneName }} a accès à de nombreuses applications parmi les plus populaires via la
                    boutique d’applications Huawei AppGallery. Vous pouvez également transférer avec Phone Clone vos
                    applications depuis votre ancien smartphone Android, et trouver vos applications via le moteur de
                    recherche sur Petal Search. Certaines applications peuvent ne pas être disponibles. Une équipe
                    d’experts Huawei est à votre disposition et joignable gratuitement au
                    <span [ngStyle]="{ 'white-space': 'nowrap' }">0800 972 285</span>
                    .
                </p>
                <p class="is-size-7 has-text-weight-light info-reminder">
                    En cliquant sur « J’ai compris » ci-dessous, j’ai bien pris connaissance du fait que ce produit
                    utilise les HUAWEI Mobile Services (HMS) en lieu et place des Google Mobile Service (GMS)
                </p>
            </div>
        </div>
        <div class="has-text-centered popin-btn">
            <trg-button (click)="cartAction()">J'ai compris</trg-button>
        </div>
    </section>
</div>
